// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3xl6s","footer":"ModalError_footer__39C4C"};